
const map:Record<string, string> = {}
    // 这里可以添加需要映射的文件路径   
export const fileMapUtils ={
    map,
    getFile(src:string):string{
        return this.map[src] || src;
    }
}